export interface GPUProbe {
  requestAdapter: () => Promise<unknown | null>;
}
export type EngineModulePath =
  "/engine/warlock_client.js" | "/engine-webgl/warlock_client.js";
/** Requesting an adapter catches unavailable drivers even when navigator.gpu exists. */
export async function chooseEngineModule(
  gpu: GPUProbe | undefined,
  timeoutMs = 2000,
): Promise<EngineModulePath> {
  if (!gpu) return "/engine-webgl/warlock_client.js";
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const adapter = await Promise.race([
      gpu.requestAdapter(),
      new Promise<null>((resolve) => {
        timer = setTimeout(() => resolve(null), timeoutMs);
      }),
    ]);
    return adapter
      ? "/engine/warlock_client.js"
      : "/engine-webgl/warlock_client.js";
  } catch {
    return "/engine-webgl/warlock_client.js";
  } finally {
    clearTimeout(timer);
  }
}
